<template>
  <div>
    <van-search show-action v-model="condition[searchProp]" :placeholder="placeholder" @search="OnSearch">
      <div slot="action" @click="OnSearch">搜索</div>
    </van-search>
    <van-list v-model="loading" :finished="finished" loading-text="加载中..." finished-text="没有更多了" offset="90"
      @load="OnLoad" class="list-box">
      <div class="list-cell" v-for="item in tableData" v-bind:key="item.id">
        <div class="list-cell-header">
          <slot name="title" :row="item">
            <div class="cell-header-left van-ellipsis">{{item[titleProp]}}</div>
          </slot>
        </div>
        <div class="list-cell-main">
          <slot name="content" :row="item">
          </slot>
        </div>
        <div class="list-cell-footer" v-show="!noFooter">
          <slot name="footer" :row="item">
          </slot>
          <van-button v-show="more" style="width: 30px;" type="info" icon="ellipsis" class="footer-button more-button"
            size="small" @click="More(item)"></van-button>
        </div>
      </div>
    </van-list>
    <van-action-sheet v-model="showAction" title="更多操作">
      <slot name="more" :row="selectItem">
      </slot>
    </van-action-sheet>

  </div>
</template>

<script>
  export default {
    name: 'ListFrame',
    data() {
      return {
        condition: {
          search: "",
          currentPage: 0,
          // pageIndex: 0,
          pageSize: 4,
          recordCount: 0,
        },
        // 数据加载中
        loading: false,
        // 数据是否加载完成
        finished: false,
        tableData: [],
        showAction: false,
        selectItem:{}
      }
    },
    props: {
      // 列表查询地址
      url: {
        type: String,
        default: ""
      },
      // 列表头绑定属性
      titleProp: {
        type: String,
        default: ""
      },
      // 查询框绑定属性
      searchProp: {
        type: String,
        default: ""
      },
      // 查询条件默认值
      contionModel: {
        type: Object,
        default: function() {
          return {}
        }
      },
      placeholder: {
        type: String,
        default: '请输入关键词搜索'
      },
      // 更多操作按钮显示控制
      more: {
        type: Boolean,
        default: false
      },
      // 是否隐藏底部操作区域
      noFooter:{
        type: Boolean,
        default: false
      },
    },
    watch: {

    },
    methods: {
      // 加载数据
      Load() {
        let that = this
        // 开始加载数据
        that.loading = true
        that.$utils.HttpPost(that.url, that.condition, function(d) {
          let dataList = d.data
          dataList.forEach(item => {
            that.tableData.push(item)
          })
          // 请求完成
          that.loading = false
          // 如果当前列表长度大于等于数据总长度，则请求结束
          if (that.tableData.length >= d.pager.recordCount) {
            that.finished = true
          }
        })
      },
      // 
      OnLoad() {
        // 当前页page+1
        this.condition.currentPage++
        this.Load()
      },
      // 点击搜索框
      OnSearch() {
        // 当前页page = 1
        this.condition.currentPage = 1
        // 重置数据完成状态
        this.finished = false
        // 置空显示数组
        this.tableData = []
        // 重新加载数据
        this.Load()
      },
      // 更多操作
      More(item) {
        this.showAction = true
        this.selectItem = this.$utils.clone(item)
      }

    },
    mounted: function() {
      let that = this
      // 将默认查询对象数据推入查询条件对象condition
      for (let key in that.contionModel) {
        that.condition[key] = that.contionModel[key]
      }
    }
  }
</script>

<style scoped>
  /*  .list-cell .list-cell-main .cell-main-row .cell-main-row-left{
    width: 90px;
  } */

  .more-button {
    flex: none;
    /* width: 30p; */
  }
</style>
